import type Client from '../client'
import PaginatedResponse from '../paginated-response'
import type {
  ErrorAble,
  InspirationParameters,
  InspirationResponse, MediaResponse,
  RequestItemBag,
} from '@/api'

export default class Inspirations {
  constructor(private client: Client) {}

  create(data: InspirationParameters): Promise<ErrorAble<InspirationResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.post('inspiration', { data }))
      } catch (error) {
        reject(error)
      }
    })
  }

  find(
    id: number,
    query: RequestItemBag = {},
  ): Promise<ErrorAble<InspirationResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.get(`inspiration/${id}`, { query }))
      } catch (error) {
        reject(error)
      }
    })
  }

  update(id: number, data: InspirationParameters): Promise<ErrorAble<InspirationResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.put(`inspiration/${id}`, { data }))
      } catch (error) {
        reject(error)
      }
    })
  }

  delete(id: number): Promise<ErrorAble<unknown>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.delete(`inspiration/${id}`))
      } catch (error) {
        reject(error)
      }
    })
  }

  list(
    page: number,
    query: RequestItemBag = {},
  ): Promise<PaginatedResponse<InspirationResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          new PaginatedResponse(
            await this.client.get('inspiration', { query: { ...query, page } }),
          ),
        )
      } catch (error) {
        reject(error)
      }
    })
  }

  media(file: File, id: number): Promise<ErrorAble<MediaResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          await this.client.post(`inspiration/${id}/media`, { data: { file } }),
        )
      } catch (error) {
        reject(error)
      }
    })
  }
}
